<app-recipes-translation-form
  *ngIf="translatedVariantsData$ | async as translatedVariantsData"
  [translatedVariantsData]="translatedVariantsData"
  (translationUpdated)="onTranslationUpdated($event)"
/>
